const BOUNCE_HUBS =
  "https://villages-28.s3.ap-south-1.amazonaws.com/app-assets/bounce_hubs.geojson";
const overlayTypes = {
  GEOJSON: "geojson",
  TEXT: "text",
};

const overlays = [
  {
    id: "hubs",
    type: overlayTypes.GEOJSON,
    name: "Bounce Hubs",
    data: BOUNCE_HUBS,
    isVisible: true,
  },
  {
    id: "hub_names",
    type: overlayTypes.TEXT,
    name: "Hub Names",
    data: BOUNCE_HUBS,
    isVisible: true,
  },
];

const gridFilter = {
  min: 0,
  max: 100,
};

const viewState = {
  longitude: 78.9629,
  latitude: 20.5937,
  zoom: 0,
  bearing: 0,
  pitch: 0,
};

const styles = [
  {
    name: "Dusk",
    url: "mapbox://styles/haxzie/ck52gt5wl4t521cqh8fq9kbme",
  },
  {
    name: "Crystal Night",
    url: "mapbox://styles/haxzie/ck0aryyna2lwq1crp7fwpm5vz",
  },
  {
    name: "Simple",
    url: "mapbox://styles/haxzie/ck2yi2gwu3gpx1co4b9ivyhbl",
  },
  {
    name: "Satellite-Streets",
    url: "mapbox://styles/mapbox/satellite-streets-v11",
  },
  {
    name: "Light",
    url: "mapbox://styles/haxzie/ck35bh5u809rl1cmsgwk9uow1",
  },
  {
    name: "Dark",
    url: "mapbox://styles/haxzie/ck35bhm884p391cm7k0pj0p4g",
  },
  {
    name: "Frozen City",
    url: "mapbox://styles/haxzie/ck0aovhaa389j1cpdls6va2f1",
  },
  {
    name: "Morning Snow",
    url: "mapbox://styles/haxzie/ck0cctlg503xe1co6hmx1kunx",
  },
];

export default function() {
  return {
    styles,
    map_style: styles[0].url,
    isMapLoaded: false,
    layers: [],
    legend: [],
    mapLegends: [],
    mapFilters: [],
    popups: [],
    cities: [],
    fetching_cities: true,
    activeCity: null,
    activeLocation: [], //[latitude,longitude]
    zoomLevel: 0,
    isTilted: false,
    geoData: null,
    measureData: null,
    showMeasureTool: false,
    activeGrid: null,
    gridFilter,
    viewState,
    overlays,
    opacity: 0.8,
    overlayTypes,
    popupData: {
      top: 0,
      left: 0,
      show: false,
    },
    contextData: {
      top: 0,
      left: 0,
      show: false,
    },
  };
}
